<div [class]="!hasTooltip() ? 'flex flex-row gap-2 items-center' : ''">
    <div
        class="status-icon-circle"
        matTooltipPosition="after"
        [class]="[
            disabled() ? 'bg-gray-300' : entityStatusesIconsProperties[status()].backgroundColor,
            `icon-size-${iconSize()}`,
        ]"
        [matTooltip]="hasTooltip() ? getStatusLabel() : ''">
        <fa-icon
            [class]="disabled() ? 'text-gray-500' : entityStatusesIconsProperties[status()].color"
            [icon]="entityStatusesIconsProperties[status()].icon"
            [size]="iconSize()" />
    </div>
    @if (!hasTooltip()) {
        <span class="pl-1 flex-1">
            {{ getStatusLabel() }}
        </span>
    }
</div>
